/**
 * 链路追踪 ID 生成（HTTP 环境降级方案）。
 *
 * crypto.randomUUID() 仅在 Secure Context（HTTPS / localhost）下可用；
 * 生产环境若为 HTTP，需降级为 Math.random 方案。
 * 启用 HTTPS 后可恢复为原生 crypto.randomUUID()。
 */
export function generateTraceId(): string {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID()
  }
  // 降级方案：拼接时间戳 + 随机数，格式符合 UUID v4
  const hex = (n: number, len = 4) => n.toString(16).padStart(len, '0')
  const t = Date.now()
  const r = () => Math.floor(Math.random() * 0xffff)
  return `${hex(t, 8)}-${hex(r())}-${hex(0x4000 | (r() & 0x3fff), 4)}-${hex(0x8000 | (r() & 0x3fff), 4)}-${hex(r(), 4)}${hex(r(), 4)}${hex(r(), 4)}`
}
